import React from 'react';
import {Link} from 'react-router-dom';

const Newsletter = () => {
  return (
    <div className='w-full py-16 text-white px-4'>
      <div className='max-w-[1240px] mx-auto grid lg:grid-cols-3'>
        <div className='lg:col-span-2 my-4'>
          <h1 className='md:text-4xl sm:text-3xl text-2xl font-bold py-2'>
            Get The Latest News!
          </h1>
          <p>Sign up to our newsletter and stay up to date.</p>
        </div>
        <div className='my-4'>
          <div className='flex flex-col sm:flex-row items-center justify-between w-full'>
            

            
            <Link to="https://docs.google.com/forms/d/e/1FAIpQLSdUbprBLId0tIrM8_T6Xp4tky7AvGQG27mxGGICaV8-OeQUSg/viewform"><button className='bg-[#3dffb1] text-black rounded-md font-medium w-[200px] ml-1 my-6 px-6 py-3'>
              Notify Me
            </button></Link>
          </div>
          <p>
            We care bout the protection of your data. Read our{' '}
            <span className='text-[#3dffb1]'>Privacy Policy.</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Newsletter;
